import { Capacitor } from '@capacitor/core';
import { differenceInMonths } from 'date-fns';
import * as Sentry from '@sentry/capacitor';
import { getAppVersion } from 'shared/envUtils';

export const getDateFromCalVer = (calVerString: string): Date => {
  const parts = calVerString.split('.');

  if (parts.length !== 3) {
    throw new Error('Invalid CalVer format. Expected YYYY.M.D');
  }

  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // JavaScript months are 0-based
  const day = parseInt(parts[2], 10);

  // Validate the parts
  if (Number.isNaN(year) || Number.isNaN(month) || Number.isNaN(day)) {
    throw new Error('Invalid CalVer format. Each part must be a number');
  }

  return new Date(year, month, day);
};

export const checkAppIsExpired = async (): Promise<boolean> => {
  if (!Capacitor.isNativePlatform()) {
    return false;
  }

  try {
    const currentAppVersion = await getAppVersion();
    const currentVersionDate = getDateFromCalVer(currentAppVersion);
    const monthsDiff = differenceInMonths(new Date(), currentVersionDate);
    return monthsDiff >= 18;
  } catch (err) {
    Sentry.captureException(err);
    return false;
  }
};
